import { render, staticRenderFns } from "./uploadSingleImage.vue?vue&type=template&id=4555f6aa&"
import script from "./uploadSingleImage.vue?vue&type=script&lang=ts&"
export * from "./uploadSingleImage.vue?vue&type=script&lang=ts&"
import style0 from "./uploadSingleImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports